<template>
  <BQdtCard
    name="complaintsRatingsTitle"
    type="header-item"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'RatingsHeader',

  components: { BQdtCard },
}
</script>
